import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useEffect, useState } from "react";
import { useAuthInternal } from "./AuthContext";
export var OidcSession = function (_ref) {
  var children = _ref.children,
    oidc = useAuthInternal().oidc,
    _useState = useState(!0),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  return useEffect(function () {
    var hasChanged = !1;
    return oidc.tryKeepExistingSessionAsync().then(function () {
      hasChanged || setIsLoading(!1);
    }), function () {
      hasChanged = !0;
    };
  }, [oidc]), React.createElement(React.Fragment, null, isLoading ? null : children);
};
OidcSession.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "OidcSession"
}, OidcSession.__docgenInfo = {
  componentName: "OidcSession",
  packageName: "@jutro/auth",
  description: "",
  displayName: "OidcSession",
  methods: [],
  actualName: "OidcSession"
};